import { ReactElement } from "react";
import { FallbackProps } from "react-error-boundary";
import { ExpandableText } from "..";
import { Button, H1, H5, imageUrls } from "@sellar-io/components";
import { NavigationBarMenu } from "../navigation/NavigationBar";

export const ErrorMessage = ({
  children,
}: {
  children?: string;
}): ReactElement => {
  return (
    <>
      <NavigationBarMenu title={"Something went wrong"} />
      <div className={"m-auto flex max-w-[600px] flex-col items-center gap-4"}>
        <div className={"py-20"}>
          <img
            alt={"Something went wrong."}
            className={"max-w-[200px]"}
            src={imageUrls.sellarLogo.purple.full}
          />
        </div>
        <H1>Something went wrong.</H1>
        <div>
          We're really sorry! Leave us your details and we'll get back to you
          ASAP. If you don't hear from us within 24 hours, we'll buy you a
          drink.
        </div>
        {children && (
          <>
            <H5>Technical details</H5>
            <ExpandableText>
              <span style={{ userSelect: "all" }}>{children}</span>
            </ExpandableText>
          </>
        )}
        <Button
          onClick={() =>
            window.open("https://form.typeform.com/to/MCcxwT", "_blank")
          }
        >
          Get help
        </Button>
      </div>
    </>
  );
};

export const ErrorMessageBoundary = ({ error }: FallbackProps) => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  return <ErrorMessage>{errorMessage}</ErrorMessage>;
};
